module.exports = __webpack_public_path__ + "static/media/20.be1d6ab9.jpg";